import { Reveal, Chapter } from "./shared";

const STEPS = [
  { n: "1", text: "We come to you", bg: "#F9CFAD" },
  { n: "2", text: "We demonstrate it live", bg: "#FCE6D2" },
  { n: "3", text: "You feel the difference", bg: "#EEF6FE" },
  { n: "4", text: "You decide", bg: "#D5E9FB" },
  { n: "5", text: "We apply the coating", bg: "#ADD5F9" },
];

export default function Demo({ onNavigate }) {
  return (
    <section
      id="demo"
      data-testid="demo-section"
      className="py-16 md:py-24 bg-white border-b border-slate-300"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <Chapter title="The On-Site Demo" note="FREE (20 MIN)" />

        <div
          data-testid="demo-steps"
          className="grid grid-cols-1 md:grid-cols-5 gap-2"
        >
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08}>
              <div
                data-testid={`demo-step-${s.n}`}
                className="h-full p-5 flex items-center gap-4 md:block"
                style={{ backgroundColor: s.bg }}
              >
                <span className="font-heading font-black text-3xl md:text-4xl text-[#0B1F33] leading-none shrink-0">
                  {s.n}
                </span>
                <span className="font-heading font-bold text-base md:text-lg text-[#0B1F33] leading-snug md:block md:mt-4">
                  {s.text}
                </span>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <p
            data-testid="demo-note"
            className="mt-8 font-bold text-base md:text-lg text-[#0B1F33]"
          >
            Live demonstration is made on our own glass samples.
          </p>
          <button
            data-testid="demo-section-cta-btn"
            onClick={() => onNavigate("quote")}
            className="mt-8 bg-[#0284C7] text-white font-semibold px-8 py-4 border border-[#0284C7] hover:bg-[#0369A1] hover:-translate-y-0.5 transition-[background-color,transform] duration-150"
          >
            Book a Free On-Site Demo
          </button>
        </Reveal>
      </div>
    </section>
  );
}
